import { useSetAtom } from 'jotai';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import React, { useRef, useState } from 'react';
import { XStack } from 'smoothie';

import { BulkMessageModal, isBulkMessageModalOpenAtom } from './BulkMessage';
import {
    MessageTemplatesModal,
    MessageTemplatesModalMode,
} from './MessageTemplates';
import { isOutOfOfficeModalOpenAtom, OutOfOfficeModal } from './OutOfOffice';

export const MessagingTools = () => {
    const setIsOutOfOfficeModalOpen = useSetAtom(isOutOfOfficeModalOpenAtom);
    const [isMessageTemplatesModalOpen, setIsMessageTemplatesModalOpen] =
        useState(false);
    const setIsBulkMessageOpen = useSetAtom(isBulkMessageModalOpenAtom);

    const menuRight = useRef<Menu>(null);
    const menuItems = [
        {
            label: 'Out Of Office Replies',
            command: () => {
                setIsOutOfOfficeModalOpen(true);
            },
        },
        {
            label: 'Message Templates',
            command: () => {
                setIsMessageTemplatesModalOpen(true);
            },
        },
        {
            label: 'Bulk Message',
            command: () => {
                setIsBulkMessageOpen(true);
            },
        },
    ];

    return (
        <XStack justifyContent="flex-end" width="100%">
            <Menu
                ref={menuRight}
                model={menuItems}
                popup
                popupAlignment="right"
            />
            <Button
                label="Messaging Tools"
                size="small"
                onClick={(event) => {
                    menuRight.current?.toggle(event);
                }}
            />
            <OutOfOfficeModal />
            <MessageTemplatesModal
                mode={MessageTemplatesModalMode.MANAGE}
                isOpen={isMessageTemplatesModalOpen}
                selectButtonLabel="Copy"
                onTemplateSelect={(template) => {
                    void navigator.clipboard.writeText(template.template);
                }}
                closeModal={() => {
                    setIsMessageTemplatesModalOpen(false);
                }}
            />
            <BulkMessageModal />
        </XStack>
    );
};
